$(document).on('click', '.js-click', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($this.attr('href'));

  if (!$element.length) {
    return;
  }

  $this.add($element).toggleClass('is-active');

  if ($this.hasClass('js-trigger-no-scroll')) {
    $('body').toggleClass('no-scroll');
  }
});
